import {Outlet} from 'react-router'

import {useAssetsQuery, useLatestQuery} from '../common/hooks'
import {isForbidden} from '../common/utils'
import {useMaterialStorageListQuery} from '../storages/hooks'

import {PermissionDeniedFallback, SettingsSkeleton} from '@settings/modules/common/components'
import {RouteName} from '@settings/modules/routing'

export const PagePlantStructure: React.FC = () => {
  const {data: latest, error: latestError} = useLatestQuery()
  const {data: assets, error: assetsError} = useAssetsQuery()
  const {data: materialStorages, error: materialStoragesError} = useMaterialStorageListQuery()

  if (isForbidden(latestError, assetsError, materialStoragesError)) {
    return <PermissionDeniedFallback dataTestId={`page_${RouteName.NOT_AUTHORIZED}`} />
  }

  if (!latest || !assets || !materialStorages) {
    return <SettingsSkeleton />
  }

  return <Outlet />
}
